import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class PreloaderService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  hidePreloader() {
    if (isPlatformBrowser(this.platformId)) {
      const preloader = document.getElementById('preloader');
      if (preloader) {
        preloader.style.opacity = '0';
        setTimeout(() => {
          preloader.remove();
        }, 600);
      }
    }
  }
}
